export const idahoCountiesList = [
    'Ada',
    'Adams',
    'Bannock',
    'Bear Lake',
    'Benewah',
    'Bingham',
    'Blaine',
    'Boise',
    'Bonner',
    'Bonneville',
    'Boundary',
    'Butte',
    'Camas',
    'Canyon',
    'Caribou',
    'Cassia',
    'Clark',
    'Clearwater',
    'Custer',
    'Elmore',
    'Franklin',
    'Fremont',
    'Gem',
    'Gooding',
    'Idaho',
    'Jefferson',
    'Jerome',
    'Kootenai',
    'Latah',
    'Lemhi',
    'Lewis',
    'Lincoln',
    'Madison',
    'Minidoka',
    'Nez Perce',
    'Oneida',
    'Owyhee',
    'Payette',
    'Power',
    'Shoshone',
    'Teton',
    'Twin Falls',
    'Valley',
    'Washington',
    ]